import {
  createCoach,
  updateCoach,
  deleteCoach,
  getListOfCoachProfile,
  getCoachandCohortList, updateCoachPin, updateInstructorStatus
} from '../../services/apiService';
import {
  setAllCoaches,
  setAllUnverifiedCoaches,
  upsertCoach,
  deleteCoach as deleteCoachReducer,
} from '../reducers/coachReducer';
import { toast } from 'react-toastify';

export function loadAllCoaches() {
  return async (dispatch) => {
    try {
      const coaches = await getCoachandCohortList();
      dispatch(setAllCoaches(coaches));
    } catch (e) {
      toast.error('Error loading Coaches');
      dispatch(setAllCoaches([]));
    }
  };
}

export function loadAllUnverifiedCoaches() {
  return async (dispatch) => {
    try {
      const unverifiedCoaches = await getListOfCoachProfile();
      dispatch(setAllUnverifiedCoaches(unverifiedCoaches));
    } catch (e) {
      toast.error('Error loading Coaches');
      dispatch(setAllUnverifiedCoaches([]));
    }
  };
}

export function createCoachAction(coach) {
  return async (dispatch) => {
    try {
      const createdCoach = await createCoach(coach);
      return dispatch(upsertCoach(createdCoach));
    } catch (e) {
      toast.error('Error creating coach');
    }
  };
}

export function updateCoachAction(coach) {
  return async (dispatch) => {
    try {
      const updatedCoach = await updateCoach(coach);
      dispatch(upsertCoach(updatedCoach));
    } catch (e) {
      toast.error('Error updating coach');
    }
  };
}

export function deleteCoachAction(coachId) {
  return async (dispatch) => {
    try {
      await deleteCoach(coachId);
      dispatch(deleteCoachReducer(coachId));
    } catch (e) {
      toast.error('Error deleting coach');
    }
  };
}

export function updatePinAction(data) {
  return async (dispatch) => {
    try {
      await updateCoachPin(data);
      const coaches = await getCoachandCohortList();
      dispatch(setAllCoaches(coaches));
    } catch (e) {
      toast.error('Error deleting coach');
    }
  };
}


export function toggleStatusAction(data) {
  return async (dispatch) => {
    try {
      await updateInstructorStatus(data);
      const coaches = await getCoachandCohortList();
      dispatch(setAllCoaches(coaches));
    } catch (e) {
      console.error('Error:', e);
      toast.error(e?.message || 'Failed to update instructor status');
    }
  };
}